export default __webpack_public_path__ + "static/media/favorite.89858788.png";